/**
 * אימייל תמיכה — סדר עדיפות:
 * 1) window.__ENV__.REACT_APP_SUPPORT_EMAIL (runtime, מ-public/env.js בפרוד)
 * 2) REACT_APP_SUPPORT_EMAIL בזמן build
 * 3) ברירת מחדל (להחליף לפני שקה סופית)
 */
const DEFAULT_SUPPORT_EMAIL = "support@notbrokenforever.com";

export function getSupportEmail() {
  if (typeof window !== "undefined" && window.__ENV__?.REACT_APP_SUPPORT_EMAIL) {
    const v = String(window.__ENV__.REACT_APP_SUPPORT_EMAIL).trim();
    if (v) return v;
  }
  if (typeof process !== "undefined" && process.env?.REACT_APP_SUPPORT_EMAIL) {
    const v = String(process.env.REACT_APP_SUPPORT_EMAIL).trim();
    if (v) return v;
  }
  return DEFAULT_SUPPORT_EMAIL;
}
